import { render } from "./addRoomvView.vue?vue&type=template&id=f170804a"
import script from "./addRoomvView.vue?vue&type=script&lang=js"
export * from "./addRoomvView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__